import React from "react";

// Without this, an uncaught error anywhere in the wrapped subtree (during
// render or in an effect) unmounts React's ENTIRE component tree by default
// — not just the component that threw. This app had no error boundary
// anywhere, which is how a WebGL failure inside SplashCursor (a purely
// decorative cursor effect, rendered first in App.js's return, on every
// page load) took the whole customer-facing site down to a blank page on
// affected devices. Falls back to rendering nothing rather than a visible
// error message, since this is meant for wrapping non-critical decorative
// pieces — the rest of the page keeps working either way.
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.warn("ErrorBoundary caught an error in a non-critical component:", error, info);
  }

  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? null;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
